module.exports = __webpack_public_path__ + "assets/img/fomede_LIBER_burger.a41f3b37.png";